// extracted by mini-css-extract-plugin
export var pillWrapper = "_ya-0";
export var showOverflow = "_ya-1";